import React, { useState } from "react";
import ShipmentPackagesModal from "./ShipmentPackagesModal";

const ShipmentPackagesPreview = ({ row }) => {
  const packages = row?.shipment_details ?? [];
  const hasPackages = packages.length > 0;
  const unit = row?.unit === "Imperial" ? " lb" : " kg";
  const [packagesModal, setPackagesModal] = useState(false);

  const getPackageStatusType = (status) => {
    const trackingStatus = String(status || "").toLowerCase();

    if (trackingStatus === "creation") {
      return "default";
    }

    if (trackingStatus === "delivered") {
      return "success";
    }

    if (trackingStatus === "cancelled" || trackingStatus === "canceled") {
      return "error";
    }

    return "processing";
  };

  // Keep all non-delivered packages first and delivered packages last.
  const sortedPackages = [...packages].sort((a, b) => {
    const aIsSuccess = getPackageStatusType(a.tracking_status) === "success";

    const bIsSuccess = getPackageStatusType(b.tracking_status) === "success";

    return Number(aIsSuccess) - Number(bIsSuccess);
  });

  const PackageStatusIndicator = ({ type }) => {
    if (type === "success") {
      return (
        <span
          className="flex h-3 w-3 items-center justify-center rounded-full bg-state-success-bg text-state-success-text"
          aria-label="Delivered"
        >
          <span className="text-[8px] font-bold leading-none">✓</span>
        </span>
      );
    }

    if (type === "error") {
      return (
        <span
          className="flex h-3 w-3 items-center justify-center rounded-full bg-state-error-bg text-state-error-text"
          aria-label="Cancelled"
        >
          <span className="text-[8px] font-bold leading-none">×</span>
        </span>
      );
    }

    if (type === "processing") {
      return (
        <span
          className="flex h-3 w-3 items-center justify-center rounded-full bg-brand-light text-brand"
          aria-label="Processing"
        >
          <span className="mb-0.5 text-[8px] font-bold leading-none tracking-[1px]">
            ...
          </span>
        </span>
      );
    }

    return (
      <span
        className="h-2 w-2 rounded-full bg-ui-border"
        aria-label="Label Created"
      />
    );
  };

  return (
    <>
      <ShipmentPackagesModal
        open={packagesModal}
        shipmentId={row?.id}
        shipmentTracking={row?.shipment_tracking_id}
        unit={row?.unit}
        onClose={() => setPackagesModal(false)}
      />

      <div
        onClick={hasPackages ? () => setPackagesModal(true) : undefined}
        className={`group flex w-full flex-nowrap items-center gap-1 rounded-md p-0.5 scrollbar-hide ${
          hasPackages
            ? "cursor-pointer overflow-x-auto transition-colors duration-150 hover:bg-ui-row-hover"
            : ""
        }`}
      >
        {hasPackages ? (
          sortedPackages.map((pkg, index) => {
            const statusType = getPackageStatusType(pkg.tracking_status);

            return (
              <div
                key={pkg.id ?? index}
                title={`Package: ${index + 1}\nDescription: ${
                  pkg.description || "N/A"
                }\nStatus: ${
                  pkg.tracking_status || "N/A"
                }\nWeight: ${pkg.weight ?? "N/A"}${unit}`}
                className="group/package relative flex shrink-0 items-center rounded border border-ui-border bg-ui-surface px-1.5 py-0.5 pr-2 transition-colors duration-150 group-hover:border-brand-light"
              >
                {/* Weight */}
                <span className="whitespace-nowrap text-[11px] font-medium leading-none text-ui-text transition-colors duration-150 group-hover:text-brand">
                  {pkg.weight}
                  {unit}
                </span>

                {/* Status Indicator */}
                <span className="absolute -right-1 -top-1">
                  <PackageStatusIndicator type={statusType} />
                </span>
              </div>
            );
          })
        ) : (
          <span className="text-xs text-ui-muted">-</span>
        )}
      </div>
    </>
  );
};

export default ShipmentPackagesPreview;
